'use client';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { CLASSNAME_FULL_WIDTH } from '@s7/base';
import { useWindowScroll } from '@s7/hooks';
import { S7S7Tablet } from '@s7/icons';
import { Affix, Flex } from '@s7/layout';
import { getDefaultZIndex, packSX } from '@s7/styles';
import { AnalyticsProvider } from './analytics.js';
import { containerStyles } from './Header.styles.js';
import { useShowHeader } from './hooks/useShowHeader/useShowHeader.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const DEFAULT_HEADER_HEIGHT = 68;
const Header = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { leftSlot, rightSlot, // TODO: изменить значение после доработки системы z-index-ов
    zIndex = getDefaultZIndex('modal'), height = DEFAULT_HEADER_HEIGHT, sx, analytics } = props, others = _object_without_properties_loose(props, [
        "leftSlot",
        "rightSlot",
        "zIndex",
        "height",
        "sx",
        "analytics"
    ]);
    const showHeader = useShowHeader(height);
    const [scroll] = useWindowScroll();
    return /*#__PURE__*/ jsx(AnalyticsProvider, {
        analytics: analytics,
        children: /*#__PURE__*/ jsxs(Affix, _extends({
            ref: ref,
            "data-background": scroll.y > 0,
            "data-show": showHeader,
            position: {
                top: 0,
                left: 0
            },
            sx: [
                containerStyles,
                {
                    zIndex
                },
                ...packSX(sx)
            ],
            withinPortal: false
        }, others, {
            children: [
                leftSlot != null ? leftSlot : /*#__PURE__*/ jsx(S7S7Tablet, {
                    size: 44
                }),
                rightSlot && /*#__PURE__*/ jsx(Flex, {
                    className: CLASSNAME_FULL_WIDTH,
                    spacing: "2s",
                    children: rightSlot
                })
            ]
        }))
    });
});

export { Header, Header as default };
//# sourceMappingURL=Header.js.map
